<article class="post">
  @if (dataList && dataList.length > 0) {
    <div class="row">
      @for (chapter of getDisplayChapters(); track chapter; let i = $index) {
        <div [class]="getColumnClass()">
          <div class="chapter-container">
            <div class="post-content">
              <!-- Chapter Title -->
              <h5>
                <a class="from-journal chapter-title-link"
                  [routerLink]="['/book', chapter.bookSlug || this.parentSlug, 'chapter', chapter.slug]" [title]="chapter.title">
                  {{ getChapterDisplayTitle(chapter) }}
                </a>
              </h5>
              <!-- Alternative Title -->
              @if (chapter.titleAlternate && chapter.titleAlternate.trim()) {
                <p class="mb-1 title-alternate">
                  {{ chapter.titleAlternate }}
                </p>
              }
              <!-- Chapter Abstract (only if includeAbstract is true) -->
              @if (shouldShowAbstract(chapter)) {
                <div class="mb-1 abstract"
                  [innerHTML]="getFormattedAbstract(chapter.abstract!)">
                </div>
              }
              <!-- Authors -->
              @if (chapter.authors && chapter.authors.length > 0) {
                <div class="post-meta">
                  <span class="authors-list">
                    @for (author of chapter.authors; track author; let authorIndex = $index) {
                      <span>
                        <app-author-view [author]="author"></app-author-view>
                        @if (authorIndex < chapter.authors.length - 1) {
                          <span>,&nbsp;</span>
                        }
                      </span>
                    }
                  </span>
                </div>
              }
              <!-- Chapter Metadata -->
              <div class="post-meta">
                <div class="row">
                  <!-- DOI Section -->
                  @if (hasDoi(chapter)) {
                    <div class="col-md-6">
                      <div class="doi-container">
                        <span class="doi-label from-journal">
                          {{ 'DOI' | translate }} :
                        </span>
                        <a class="doi-value"
                          [title]="'DOI' | translate"
                          [href]="getDoiUrl(chapter.doi!)"
                          style="cursor: pointer;">
                          {{ chapter.doi }}
                        </a>
                      </div>
                    </div>
                  }
                  <!-- Badges Section -->
                  <div class="col-md-6 text-right">
                    <div class="badges-container">
                      <!-- Section Badge -->
                      @if (chapter.section) {
                        <span class="badge badge-custom badge-sm mr-2">
                          {{ chapter.section | translate }}
                        </span>
                      }
                      <!-- Language Badge -->
                      @if (chapter.localeText) {
                        <span class="badge badge-custom badge-sm mr-2 text-uppercase">
                          {{ getLanguageCode(chapter.localeText) }}
                        </span>
                      }
                      <!-- Page Range Badge -->
                      @if (hasPageNumbers(chapter)) {
                        <span class="badge badge-custom badge-sm mr-2">
                          {{ 's.' | translate }}. {{ getPageRange(chapter) }}
                        </span>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Separator (except for last item) -->
            @if (!isLastItem(i)) {
              <hr class="chapter-separator">
            }
          </div>
        </div>
      }
    </div>
  }

  <!-- No Chapters Message -->
  @if (!dataList || dataList.length === 0) {
    <div class="no-chapters-message">
      <div class="text-center text-muted py-4">
        <i class="fas fa-book-open fa-2x mb-2"></i>
        <p>{{ 'noChapters' | translate }}</p>
      </div>
    </div>
  }

  <!-- Load More Section (if there are more chapters) -->
  @if (dataList && dataList.length > count) {
    <div class="load-more-section text-center mt-3">
      <p class="text-muted">
        {{ 'showingCount' | translate }}
        <strong>{{ count }}</strong>
        {{ 'outOf' | translate }}
        <strong>{{ dataList.length }}</strong>
        {{ 'chapters' | translate }}
      </p>
    </div>
  }
</article>